// extracted by mini-css-extract-plugin
export default {"aboutPage":"about_aboutPage__Kv0Xx"};